import CartsAPI from 'dashboard/api/pipelines/carts';

const state = {
  records: [],
  meta: {},
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  getCarts: _state => _state.records,
  getMeta: _state => _state.meta,
  getCart: _state => id => _state.records.find(c => c.id === id) || null,
  getUIFlags: _state => _state.uiFlags,
};

export const actions = {
  fetchCarts: async ({ commit }, { accountId, params = {} }) => {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await CartsAPI.getCarts(accountId, params);
      const payload  = response.data?.data?.payload || [];
      const meta     = response.data?.data?.meta || {};
      commit('SET_CARTS', { carts: payload, meta });
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },
};

export const mutations = {
  SET_UI_FLAG(_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },

  SET_CARTS(_state, { carts, meta }) {
    _state.records = Array.isArray(carts) ? carts : [];
    _state.meta    = meta;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
